export default __webpack_public_path__ + "assets/svg/Hexbar.7e48c3eeac9f75b8b106e96bf115a00f.svg";